import {
    GET_GENDER_CATEGORY_REQUEST,
    GET_GENDER_CATEGORY_SUCCESS,
    GET_GENDER_CATEGORY_ERROR,

} from "../actions/types"
export default function (state = [], action) {
    const { type, payload } = action;
    switch (type) {
        case GET_GENDER_CATEGORY_REQUEST:
            return {
                loading: true,
            };
        case GET_GENDER_CATEGORY_SUCCESS:
            return {
                ...state,
                loading: false,
                payload,
            };
        case GET_GENDER_CATEGORY_ERROR:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
}